import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setStatus("fail"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("fail"));
  }, [params]);

  return (
    <div className="min-h-screen bg-base text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md border border-white/10 bg-panel p-10 text-center" data-testid="verify-email-card">
        <div className="font-heading font-black text-2xl tracking-tight text-signal mb-6">SNETCH</div>
        {status === "verifying" && (
          <div className="flex flex-col items-center gap-4" data-testid="verify-status-verifying">
            <Loader2 className="w-10 h-10 text-signal animate-spin" />
            <p className="font-mono text-sm text-white/60">{t("verify_verifying")}</p>
          </div>
        )}
        {status === "ok" && (
          <div className="flex flex-col items-center gap-4" data-testid="verify-status-ok">
            <CheckCircle2 className="w-12 h-12 text-profit" />
            <p className="font-heading font-bold text-xl">{t("verify_success")}</p>
            <Link to="/lobby" data-testid="verify-go-lobby" className="mt-2 inline-block bg-signal text-base font-mono font-bold uppercase tracking-wide px-6 py-2.5 rounded-sm hover:opacity-90 transition-opacity">
              {t("back_lobby")}
            </Link>
          </div>
        )}
        {status === "fail" && (
          <div className="flex flex-col items-center gap-4" data-testid="verify-status-fail">
            <XCircle className="w-12 h-12 text-loss" />
            <p className="font-heading font-bold text-xl">{t("verify_fail")}</p>
            <Link to="/lobby" data-testid="verify-go-lobby" className="mt-2 inline-block border border-white/20 text-white/80 font-mono uppercase tracking-wide px-6 py-2.5 rounded-sm hover:bg-white/5 transition-colors">
              {t("back_lobby")}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
